import React, { useState } from "react";
import "../../styles/FloatingLabelInput.css";
import { FaTimesCircle } from "react-icons/fa";

const FloatingLabelInput = ({
  label,
  type = "text",
  value,
  onChange,
  clearValue,
  error = false,
  ...rest
}) => {
  const [isFocused, setFocused] = useState(false);

  return (
    <div className={`input-wrapper ${error ? "error" : ""}`}>
      <input
        type={type}
        className={`floating-input ${isFocused || value ? "has-text" : ""}`}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...rest}
      />

      {value && clearValue && (
        <span className="clear-icon text-black" onClick={clearValue}>
          <FaTimesCircle />
        </span>
      )}

      <label className={`floating-label ${isFocused || value ? "float" : ""}`}>
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelInput;
